import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MessageService } from '../../message.service';
import { Conversation, User } from '../../../reservation/reservation.model';
import { TableName } from '../../../common/enums/TableName';
import { InfoboxService } from '../../../common/infobox/infobox.service';
import { debounceTime, distinctUntilChanged, from, Observable, startWith, switchMap } from 'rxjs';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';

export enum DialogType {
	RESERVATION = 'reservation',
	USER = 'user',
}

@Component({
	selector: 'app-message-assign-dialog',
	templateUrl: './message-assign-dialog.component.html',
	styleUrls: ['./message-assign-dialog.component.scss'],
})
export class MessageAssignDialogComponent implements OnInit {
	constructor(
		@Inject(MAT_DIALOG_DATA)
		public data: { thread: Conversation[]; type: DialogType },
		private readonly service: MessageService,
		public dialogRef: MatDialogRef<MessageAssignDialogComponent>,
		private readonly infobox: InfoboxService,
	) {}
	@ViewChild('userInput') userInput: ElementRef<HTMLInputElement>;
	protected resId: number = null;
	protected filteredUsers: Observable<User[]>;
	protected users: User[] = [];
	protected userCtr = new FormControl('');

	ngOnInit() {
		this.filteredUsers = this.userCtr.valueChanges.pipe(
			startWith(''),
			debounceTime(300),
			distinctUntilChanged(),
			switchMap((value) => {
				if (value.length < 3) return [];
				return from(this.service.getUsers(value));
			}),
		);
	}

	protected setResId(resId: number) {
		this.resId = resId;
	}

	protected remove(user: User): void {
		const index = this.users.indexOf(user);
		if (index >= 0) {
			this.users.splice(index, 1);
		}
	}

	protected selected(event: MatAutocompleteSelectedEvent): void {
		this.users.push(event.option.value);
		this.userInput.nativeElement.value = '';
		this.userCtr.setValue('');
	}

	protected async assignThreads() {
		const requests = [];

		if (this.data.type === DialogType.RESERVATION) {
			const tableObj = {
				tableId: this.resId,
				tableName: TableName.RESERVATION,
			};
			this.data.thread.forEach((thread) => requests.push(this.service.patchThread(thread.id, tableObj)));
		}

		if (this.data.type === DialogType.USER) {
			this.data.thread.forEach((thread) => {
				const userIds = this.users.map((user) => user.id);
				requests.push(this.service.watchThread(thread.id, userIds));
			});
		}

		Promise.all(requests).then(() => {
			this.dialogRef.close(true);
		});
	}

	protected readonly DialogType = DialogType;
}
